import PropTypes from 'prop-types';
import { textAreaShape } from './text-area';
export const textCardShape = Object.assign(Object.assign({}, textAreaShape), { oneCell: PropTypes.bool, fourCells: PropTypes.bool, promoClick: PropTypes.func });
//# sourceMappingURL=text-card.js.map